import { render, staticRenderFns } from "./MyUpload.vue?vue&type=template&id=445725e6"
import script from "./MyUpload.vue?vue&type=script&lang=js"
export * from "./MyUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports